/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createContext, useContext, useState, useEffect } from 'react';

interface ActiveProfileContextType {
  activeProfileId: string | null;
  setActiveProfileId: (id: string | null) => void;
  refreshProfileData: () => void;
}

const ActiveProfileContext = createContext<ActiveProfileContextType | undefined>(undefined);

export const useActiveProfile = () => {
  const context = useContext(ActiveProfileContext);
  if (!context) {
    throw new Error('useActiveProfile must be used within ActiveProfileProvider');
  }
  return context;
};

export const ActiveProfileProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeProfileId, setActiveProfileId] = useState<string | null>(() => {
    return sessionStorage.getItem('activeProfileId') || null;
  });
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const refreshProfileData = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  useEffect(() => {
    if (activeProfileId) {
      sessionStorage.setItem('activeProfileId', activeProfileId);
      // Dispatch event for other components to react
      window.dispatchEvent(new CustomEvent('activeProfileChanged', { 
        detail: { profileId: activeProfileId } 
      }));
    } else {
      sessionStorage.removeItem('activeProfileId');
    }
  }, [activeProfileId]);

  return (
    <ActiveProfileContext.Provider value={{ activeProfileId, setActiveProfileId, refreshProfileData }}>
      {children}
    </ActiveProfileContext.Provider>
  );
};
